import React from 'react';
import { Cable } from 'lucide-react';
import { productCatalog } from '../../data/productCatalog';

const ProductCard = ({ product }) => (
  <div
    className="bg-gray-900 border border-gray-800 rounded-lg p-4 hover:border-amber-500 transition-all cursor-pointer group"
    data-testid={`product-card-${product.id}`}
  >
    <div className="aspect-square bg-transparent rounded-lg mb-3 overflow-hidden flex items-center justify-center">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
      />
    </div>
    <p className="text-center text-sm text-white font-medium">{product.name}</p>
  </div>
);

const PlaceholderCard = ({ text }) => (
  <div className="bg-gray-900 border border-gray-800 rounded-lg p-4 hover:border-amber-500 transition-all">
    <div className="aspect-square bg-gray-800 rounded-lg mb-3 flex items-center justify-center">
      <Cable className="h-12 w-12 text-gray-600" />
    </div>
    <p className="text-center text-sm text-gray-400">{text}</p>
  </div>
);

const ProductGrid = ({ products, placeholder }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
    {products.length === 0 && placeholder ? (
      <PlaceholderCard text={placeholder} />
    ) : (
      products.map((product) => <ProductCard key={product.id} product={product} />)
    )}
  </div>
);

const SubCategoryBlock = ({ subCategory }) => (
  <div className="mb-10" data-testid={`subcategory-${subCategory.id}`}>
    <h4 className="text-2xl font-semibold text-amber-500 mb-6 pl-4">
      {subCategory.title}
    </h4>
    <ProductGrid
      products={subCategory.products}
      placeholder={subCategory.placeholder}
    />
  </div>
);

const CategoryBlock = ({ category }) => (
  <div className="mb-16" data-testid={`category-${category.id}`}>
    <h3 className="text-3xl font-bold text-white mb-8 border-b border-amber-500 pb-3">
      {category.title}
    </h3>
    {category.subCategories ? (
      category.subCategories.map((sub) => (
        <SubCategoryBlock key={sub.id} subCategory={sub} />
      ))
    ) : (
      <ProductGrid products={category.products || []} />
    )}
  </div>
);

export const Products = () => (
  <section id="products" className="py-20 px-4 bg-gradient-to-b from-black to-gray-900" data-testid="products-section">
    <div className="container mx-auto">
      <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center">
        Our <span className="text-amber-500">Products</span>
      </h2>
      <p className="text-center text-gray-400 mb-16 max-w-2xl mx-auto">
        Explore our comprehensive range of electrical solutions designed for reliability and performance
      </p>
      {productCatalog.map((category) => (
        <CategoryBlock key={category.id} category={category} />
      ))}
    </div>
  </section>
);
